const ITEMS = [
  "USDT to INR Exchange",
  "Cash Deposit Support",
  "Secure Order Management",
  "Transparent Orders",
  "Fast & Simple",
  "Mobile Friendly",
];

const Row = ({ ariaHidden }) => (
  <div aria-hidden={ariaHidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-mono text-sm font-semibold uppercase tracking-[0.2em] text-slate-400">
          {item}
        </span>
        <span className="inline-block h-1.5 w-1.5 rotate-45 bg-emerald-500/70" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="brand-marquee"
      className="relative border-y border-white/[0.06] bg-navy-900/60 py-5"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#04070F] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#04070F] to-transparent" />
      <div className="flex w-max marquee-track">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
